"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_acdc_1 = require("@seaweb/react-acdc");
var SelectContext_1 = require("./SelectContext");
var SelectSelectedOnMount = function () {
    var value = SelectContext_1.useSelectContext().value;
    var dispatch = react_acdc_1.useAcdcContext().dispatch;
    var getValueMap = react_acdc_1.useAcdcElementRegistryContext().getValueMap;
    react_1.useEffect(function () {
        if (value !== null) {
            var selectedPair = Object.entries(getValueMap()).find(function (_a) {
                var _b = __read(_a, 2), val = _b[1];
                return val === value;
            });
            var selectedIndex = selectedPair ? +selectedPair[0] : null;
            dispatch({
                type: react_acdc_1.ActionTypes.MergeState,
                state: {
                    selectedIndex: selectedIndex,
                    keyboardHighlightedIndex: selectedIndex,
                },
            });
        }
    }, []);
    return null;
};
exports.default = SelectSelectedOnMount;
